'use client';

import { FC } from 'react';
import { Content } from '@prismicio/client';
import { BoxContainer, Container } from '@/components';

import { TextContent, Cards } from '..';
import styles from './borrowMoreInner.module.scss';
import { useVisible } from '@/hooks';

type Props = {
  slice: Content.BorrowMoreSlice;
};

export const BorrowMoreInner: FC<Props> = ({ slice }) => {
  const [isVisible, id] = useVisible();

  return (
    <BoxContainer styles={styles[slice.variation]}>
      <Container styles={styles.container} id={id}>
        <div className={styles.inner}>
          <TextContent slice={slice} isVisible={isVisible} />
          <Cards slice={slice} isVisible={isVisible} />
        </div>
      </Container>
    </BoxContainer>
  );
};
